// extracted by mini-css-extract-plugin
export default {"wrapper":"Tooltip_wrapper__eHeTf","tooltip":"Tooltip_tooltip__f-FiD"};